import React, { useContext, useEffect, useState, Fragment } from "react";
import AuthContext from "../../contexts/AuthContext";
import CircularProgress from "../../components/CircularProgress";
import ThemeMiddleware from "./ThemeMiddleware";
import { ShowError } from "../../helper/Alert";
import { useReactOidc } from "@axa-fr/react-oidc-context";
import FaraGostarHttp from "../../api/FaraGostarHttp";
import LocalStorageService from "../../api/LocalStorageService";

const AuthMiddleware = (props: any) => {
  const { oidcUser, events } = useReactOidc() as any;
  const authContext = useContext(AuthContext);
  let userEp = authContext.userEmployeePosition;

  useEffect(() => {
    async function getUserEmployeePosition() {
      try {
        let http = await FaraGostarHttp();
        let t1 = new Date();
        console.log("t", t1);
        let response = await http.get("dashboard/getUserEmployeePosition");
        let t2 = new Date().getTime();
        // if (t2 - t1 > 0) alert(t2 - t1);
        let data = response.data;

        const targetItem = (item: any) => item.isDefault === true;
        let filteredData = data.filter(targetItem);
        let isDefault = filteredData.length ? filteredData[0] : data[0];

        LocalStorageService.setUserPersonCode(isDefault.personCode);

        if (authContext.setUserEmployeePosition && authContext.setUserRoles) {
          authContext.setUserEmployeePosition(isDefault);
          authContext.setUserRoles(data);
        }
      } catch (error) {
        // alert(JSON.stringify(error, undefined, 4));
        return ShowError("", error);
      }
    }

    if (!userEp.personCode) {
      getUserEmployeePosition();
    }
  }, [authContext]);

  useEffect(() => {
    userEpHandler();

    async function userEpHandler() {
      let usrEp = LocalStorageService.getUserPersonCode();

      if (userEp.personCode && usrEp && usrEp !== userEp.personCode)
        LocalStorageService.setUserPersonCode(userEp.personCode);
    }
  });

  // if (!userEp.personCode && !LocalStorageService.getUserPersonCode()) {
  if (!userEp.personCode) {
    return (
      <div className="gx-main-content-wrapper">
        <CircularProgress className="" />
      </div>
    );
  }

  return <ThemeMiddleware {...props} />;
};

export default AuthMiddleware;
